import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

//https://stackoverflow.com/questions/36895431/angular2-pipes-how-to-format-a-phone-number

@Pipe({ name: 'safeHtml' })

export class safeHtmlPipe implements PipeTransform {

	constructor(private sanitizer: DomSanitizer) { }

	transform(val: string, args: any) {
		return this.sanitizer.bypassSecurityTrustHtml(val);
	}
}
